import { render, staticRenderFns } from "./promoters.vue?vue&type=template&id=2d6bb658&scoped=true&"
import script from "./promoters.vue?vue&type=script&lang=js&"
export * from "./promoters.vue?vue&type=script&lang=js&"
import style0 from "./promoters.vue?vue&type=style&index=0&id=2d6bb658&lang=less&scoped=true&"
import style1 from "./promoters.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6bb658",
  null
  
)

export default component.exports